// Some starter smooth scrolling JS
// Uses jQuery animate() method - https://api.jquery.com/animate/
(function($) {
	var headerOffset = 160;
	var headerHeight = 0;
	var header = $('header.site-header');

	if ($('body.page-template-pei').length) {
		headerOffset = 100;
	}

	// Add smooth scrolling to all links
	$("a").not('.open-popup-link, .gform_button').on('click', function(event) {

		//Exclude anchors inside p.open-popup-link
		let parent = $(this).parent();
		if (parent.hasClass('open-popup-link')) {
			return;
		}

		// Make sure this.hash has a value before overriding default behavior
		if (this.hash !== '') {
			// Store hash
			var hash = this.hash;

			//only intercept if the hash is on the page
			if (!$(hash).length) return;

			//If the mobile menu is open, close it
			let mobileMenuToggle = $('.main-menu-toggle');

			if (mobileMenuToggle && mobileMenuToggle.hasClass('cross')) {
				$(".main-menu-toggle").toggleClass("cross");
				$("body").toggleClass("modal-open");
				$(".main-navigation").toggleClass("open");
				$(".mobile-primary").toggleClass("open");
			}

			// Prevent default anchor click behavior
			event.preventDefault();
			headerHeight = header.height(); // Get fixed header height

			// Using jQuery's animate() method to add smooth page scroll
			// The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
			$('html, body').animate({
				scrollTop: $(hash).offset().top - (headerHeight + headerOffset)
			}, 800) ;
		} // End if
	});

	if(window.location.hash && $(window.location.hash).length) {
		var $section = $(window.location.hash);

		if ($section.hasClass('standard-modal')) {
			return;
		}

		// smooth scroll to the anchor id
		// event.preventDefault();
		headerHeight = header.hasClass('is-sticky') ? header.height() : 0; // Get fixed header height

		$('html, body').animate({
			scrollTop: $(window.location.hash).offset().top - (headerHeight + headerOffset)
		}, 800);
	}
})(jQuery);
